// src/constants/colors.js
// Color mappings for badges, statuses, and UI elements

/**
 * Tier badge colors
 */
export const TIER_BADGE_COLORS = {
    BASIC: 'bg-gray-600 text-gray-100',
    PRO: 'bg-blue-600 text-blue-100',
    ENTERPRISE: 'bg-purple-600 text-purple-100',
};

/**
 * Status badge colors
 */
export const STATUS_BADGE_COLORS = {
    PENDING: 'bg-yellow-900 text-yellow-300',
    ACCEPTED: 'bg-green-900 text-green-300',
    REJECTED: 'bg-red-900 text-red-300',
    EXPIRED: 'bg-gray-700 text-gray-400',
    CANCELLED: 'bg-gray-700 text-gray-400',
    ACTIVE: 'bg-green-900 text-green-300',
    INACTIVE: 'bg-gray-700 text-gray-400',
    COMPLETED: 'bg-blue-900 text-blue-300',
    FAILED: 'bg-red-900 text-red-300',
    RUNNING: 'bg-yellow-900 text-yellow-300',
    TRIAL: 'bg-purple-900 text-purple-300',
    SUBSCRIBED: 'bg-green-900 text-green-300',
};

/**
 * Role badge colors
 */
export const ROLE_BADGE_COLORS = {
    ADMIN: 'bg-red-900 text-red-300',
    MANAGER: 'bg-blue-900 text-blue-300',
    USER: 'bg-gray-700 text-gray-300',
};

/**
 * Module badge colors
 */
export const MODULE_BADGE_COLORS = {
    core: 'bg-emerald-900 text-emerald-300',
    export: 'bg-cyan-900 text-cyan-300',
    notifications: 'bg-yellow-900 text-yellow-300',
    search: 'bg-blue-900 text-blue-300',
    documents: 'bg-orange-900 text-orange-300',
    analytics: 'bg-purple-900 text-purple-300',
    users: 'bg-pink-900 text-pink-300',
    integrations: 'bg-indigo-900 text-indigo-300',
    support: 'bg-green-900 text-green-300',
    branding: 'bg-red-900 text-red-300',
    compliance: 'bg-amber-900 text-amber-300',
    infrastructure: 'bg-slate-700 text-slate-300',
};

/**
 * Job status colors (standard dark theme)
 */
export const JOB_STATUS_COLORS = {
    PENDING: 'bg-yellow-900 text-yellow-300',
    RUNNING: 'bg-blue-900 text-blue-300',
    COMPLETED: 'bg-green-900 text-green-300',
    FAILED: 'bg-red-900 text-red-300',
    CANCELLED: 'bg-gray-700 text-gray-400',
};

/**
 * Job status colors (brutalist high-contrast style)
 */
export const JOB_STATUS_STYLES_BRUTALIST = {
    PENDING: 'bg-yellow-500 text-black',
    RUNNING: 'bg-blue-500 text-white',
    COMPLETED: 'bg-green-500 text-black',
    FAILED: 'bg-red-600 text-white',
    CANCELLED: 'bg-gray-500 text-white',
};

/**
 * Workflow colors
 */
export const WORKFLOW_COLORS = {
    blue: 'bg-blue-900 text-blue-300 border-blue-700',
    cyan: 'bg-cyan-900 text-cyan-300 border-cyan-700',
    purple: 'bg-purple-900 text-purple-300 border-purple-700',
    green: 'bg-green-900 text-green-300 border-green-700',
    orange: 'bg-orange-900 text-orange-300 border-orange-700',
    pink: 'bg-pink-900 text-pink-300 border-pink-700',
    yellow: 'bg-yellow-900 text-yellow-300 border-yellow-700',
};

/**
 * Priority colors
 */
export const PRIORITY_COLORS = {
    LOW: 'bg-green-900 text-green-300',
    NORMAL: 'bg-blue-900 text-blue-300',
    HIGH: 'bg-orange-900 text-orange-300',
    CRITICAL: 'bg-red-900 text-red-300',
};

/**
 * Get tier badge color
 */
export const getTierBadgeColor = (tier) => {
    return TIER_BADGE_COLORS[tier] || TIER_BADGE_COLORS.BASIC;
};

/**
 * Get status badge color
 */
export const getStatusBadgeColor = (status) => {
    return STATUS_BADGE_COLORS[status] || 'bg-gray-700 text-gray-400';
};

/**
 * Get role badge color
 */
export const getRoleBadgeColor = (role) => {
    return ROLE_BADGE_COLORS[role] || ROLE_BADGE_COLORS.USER;
};

/**
 * Get module badge color
 */
export const getModuleBadgeColor = (module) => {
    return MODULE_BADGE_COLORS[module] || 'bg-gray-700 text-gray-300';
};

/**
 * Get job status color
 */
export const getJobStatusColor = (status) => {
    return JOB_STATUS_COLORS[status] || JOB_STATUS_COLORS.PENDING;
};

/**
 * Get brutalist job status style (high contrast)
 */
export const getJobStatusStyleBrutalist = (status) => {
    return JOB_STATUS_STYLES_BRUTALIST[status] || JOB_STATUS_STYLES_BRUTALIST.PENDING;
};

/**
 * Get priority color
 */
export const getPriorityColor = (priority) => {
    return PRIORITY_COLORS[priority] || PRIORITY_COLORS.NORMAL;
};

/**
 * Get workflow color
 */
export const getWorkflowColor = (colorName) => {
    return WORKFLOW_COLORS[colorName] || WORKFLOW_COLORS.blue;
};
